import { render, staticRenderFns } from "./CardPalette.vue?vue&type=template&id=5a6da640"
import script from "./CardPalette.vue?vue&type=script&lang=js"
export * from "./CardPalette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports